"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_1 = __importDefault(require("@emotion/styled"));

var theme_1 = require("../../../styles/theme");

var Section = styled_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  font-family: 'DM Sans', sans-serif;\n  padding: ", " 6rem;\n\n  ", " {\n    padding: 2rem;\n  }\n"], ["\n  background-color: ", ";\n  font-family: 'DM Sans', sans-serif;\n  padding: ", " 6rem;\n\n  ", " {\n    padding: 2rem;\n  }\n"])), function (props) {
  return props.backgroundColor || theme_1.silvur.colors.lightGray;
}, function (props) {
  return props.compact ? '2rem' : '4rem';
}, theme_1.theme.breakpoints.tabletDown);
var Title = styled_1["default"].h2(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 700;\n"], ["\n  color: ", ";\n  font-weight: 700;\n"])), theme_1.silvur.colors.gray);
var SubTitle = styled_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 500;\n"], ["\n  color: ", ";\n  font-weight: 500;\n"])), theme_1.silvur.colors.gray);
var SectionContent = styled_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: grid;\n  grid-gap: 3rem;\n  grid-template-columns: 2fr 2fr 1fr;\n  \n  ", " {\n    grid-gap: 1rem 0.5rem;\n  }\n"], ["\n  display: grid;\n  grid-gap: 3rem;\n  grid-template-columns: 2fr 2fr 1fr;\n  \n  ", " {\n    grid-gap: 1rem 0.5rem;\n  }\n"])), theme_1.theme.breakpoints.tabletDown);
var LegalInfoContent = styled_1["default"].div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  grid-column-start: auto;\n  grid-column-end: span 1;\n  color: ", ";\n  font-weight: 400;\n\n  ", " {\n    grid-column-end: span 3;\n  }\n"], ["\n  grid-column-start: auto;\n  grid-column-end: span 1;\n  color: ", ";\n  font-weight: 400;\n\n  ", " {\n    grid-column-end: span 3;\n  }\n"])), theme_1.silvur.colors.gray, theme_1.theme.breakpoints.tabletDown);
var Link = styled_1["default"].a(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var _b = _a.color,
      color = _b === void 0 ? theme_1.silvur.colors.gray : _b;
  return color;
});

var LegalInfo = function LegalInfo(props) {
  return react_1["default"].createElement(Section, __assign({}, props), react_1["default"].createElement(Title, null, "Legal"), react_1["default"].createElement(SectionContent, null, react_1["default"].createElement(LegalInfoContent, null, "This website is maintained by Kindur Services Inc. (\u201CKindur Services\u201D). By using this website, you accept our ", react_1["default"].createElement(Link, {
    color: theme_1.silvur.colors.gray,
    href: "https://app.kindur.com/Kindur_Terms_of_Use.pdf",
    target: "_top"
  }, "Terms of Use"), " and ", react_1["default"].createElement(Link, {
    color: theme_1.silvur.colors.gray,
    href: "https://www.kindur.com/privacy/",
    target: "_top"
  }, "Privacy Policy"), ". Investment advisory services provided only to those who enter a written agreement to become clients of Kindur Investment Services LLC. Review important information about advisory services ", react_1["default"].createElement(Link, {
    color: theme_1.silvur.colors.gray,
    href: "https://app.kindur.com/disclosures/?utm_source=email&utm_medium=footer",
    target: "_top"
  }, "here"), "."), react_1["default"].createElement(LegalInfoContent, null, "Nothing on this website is an offer to buy or sell any security or an offer or solicitation in any jurisdiction where we are not authorized to do business.", react_1["default"].createElement("br", null), react_1["default"].createElement("br", null), "The Silvur app is independent from services offered by Kindur Investment and is subject to Silvur\u2019s separate ", react_1["default"].createElement(Link, {
    color: theme_1.silvur.colors.gray,
    href: "https://www.silvur.com/terms/?utm_source=email&utm_medium=kindur_footer",
    target: "_top"
  }, "Terms of Use"), " and ", react_1["default"].createElement(Link, {
    color: theme_1.silvur.colors.gray,
    href: "https://www.silvur.com/privacy/",
    target: "_top"
  }, "Privacy Policy"), "."), react_1["default"].createElement(LegalInfoContent, null, react_1["default"].createElement(SubTitle, null, "Kindur"), react_1["default"].createElement("br", null), "147 W 24th Street, 6th Floor ", react_1["default"].createElement("br", null), "New York, NY 10011 ", react_1["default"].createElement("br", null), "Email: ", react_1["default"].createElement(Link, {
    color: theme_1.silvur.colors.darkGreen,
    href: "mailto:support@kindur.com"
  }, "support@kindur.com"), " ", react_1["default"].createElement("br", null), "\xA9 Copyright 2020 ", react_1["default"].createElement("br", null), "Kindur Services Inc.", react_1["default"].createElement("br", null), react_1["default"].createElement("br", null), react_1["default"].createElement(Link, {
    color: theme_1.silvur.colors.gray,
    href: 'https://app.kindur.com/legal'
  }, "Legal Info"))));
};

exports["default"] = LegalInfo;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;